import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompanyCategory } from "../../../model/company";
const initialState: {
  categories: CompanyCategory[];
  error: boolean;
  pending: boolean;
} = {
  categories: [],
  pending: false,
  error: false,
};

export const companyCategoryStore = createSlice({
  name: "companyCategoryStore",
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<CompanyCategory[]>) {
      state.categories = action.payload;
    },
    setPending(state) {
      state.pending = true;
    },
    setError(state) {
      state.error = true;
    },
  },
});

export const { setCategories, setError, setPending } =
  companyCategoryStore.actions;
